const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      50: '#F4F8FC', // secondary.w10
      100: '#D3E2F3', // secondary.w8
      200: '#A7C5E7', // secondary.w6
      300: '#7BA8DB', // secondary.w4
      400: '#4F8BCF', // secondary.w2
      500: '#236EC3', // secondary
      600: '#1C589C', // secondary.b2
      700: '#154275', // secondary.b4
      800: '#0E2C4E', // secondary.b6
      900: '#071627', // secondary.b10
      main: '#236EC3', // secondary
      light: '#E9F1F9', // secondary.w9
      dark: '#0E2C4E', // secondary.b6
      contrastText: '#FFFFFF', // based on YIQ contrast
    },
    secondary: {
      50: '#FFF2F2', // primary.w10
      100: '#FFCCCC', // primary.w8
      200: '#FF9999', // primary.w6
      300: '#FF6666', // primary.w4
      400: '#FF3333', // primary.w2
      500: '#FF0000', // primary
      600: '#CC0000', // primary.b2
      700: '#990000', // primary.b4
      800: '#660000', // primary.b6
      900: '#330000', // primary.b10
      main: '#B30000', // primary.b3
      light: '#FFE6E6', // primary.w9
      dark: '#660000', // primary.b6
      contrastText: '#FFFFFF', // based on YIQ contrast
    },
    success: {
      50: '#F7FAF5', // success.w10
      100: '#DEE9D8', // success.w8
      200: '#BDD3B1', // success.w6
      300: '#9CBD8B', // success.w4
      400: '#7BA764', // success.w2
      500: '#5A913D', // success
      600: '#487431', // success.b2
      700: '#365725', // success.b4
      800: '#243A18', // success.b6
      900: '#121D0C', // success.b10
      main: '#5A913D', // success
      light: '#EFF4EC', // success.w9
      dark: '#243A18', // success.b6
      contrastText: '#FFFFFF', // based on YIQ contrast
    },
    info: {
      50: '#F3F9FA', // info.w10
      100: '#CDE5EC', // info.w8
      200: '#9CCCD9', // info.w6
      300: '#6AB2C7', // info.w4
      400: '#3999B4', // info.w2
      500: '#077FA1', // info
      600: '#066681', // info.b2
      700: '#044C61', // info.b4
      800: '#033340', // info.b6
      900: '#011920', // info.b10
      main: '#077FA1', // info
      light: '#E6F2F6', // info.w9
      dark: '#033340', // info.b6
      contrastText: '#FFFFFF', // based on YIQ contrast
    },
    warning: {
      50: '#FEFCF2', // warning.w10
      100: '#FCF2CC', // warning.w8
      200: '#F9E499', // warning.w6
      300: '#F6D766', // warning.w4
      400: '#F3C933', // warning.w2
      500: '#F0BC00', // warning
      600: '#C09600', // warning.b2
      700: '#907100', // warning.b4
      800: '#604B00', // warning.b6
      900: '#302600', // warning.b10
      main: '#F0BC00', // warning
      light: '#FEF8E6', // warning.w9
      dark: '#604B00', // warning.b6
      contrastText: '#000000', // based on YIQ contrast
    },
    error: {
      50: '#FCF6F5', // error.w10
      100: '#F3DBD6', // error.w8
      200: '#E8B7AD', // error.w6
      300: '#DC9283', // error.w4
      400: '#D16E5A', // error.w2
      500: '#C54A31', // error
      600: '#9E3B27', // error.b2
      700: '#762C1D', // error.b4
      800: '#4F1E14', // error.b6
      900: '#270F0A', // error.b10
      main: '#C54A31', // error
      light: '#F9EDEA', // error.w9
      dark: '#4F1E14', // error.b6
      contrastText: '#FFFFFF', // based on YIQ contrast
    },
    grey: {
      50: '#F9F9F9', // neutrals.w10
      100: '#E6E6E6', // neutrals.w8
      200: '#CCCCCC', // neutrals.w6
      300: '#B3B3B3', // neutrals.w4
      400: '#999999', // neutrals.w2
      500: '#808080', // neutrals
      600: '#666666', // neutrals.b2
      700: '#4D4D4D', // neutrals.b4
      800: '#333333', // neutrals.b6
      900: '#1A1A1A', // neutrals.b10
      main: '#808080', // neutrals
      light: '#F2F2F2', // neutrals.w9
      dark: '#333333', // neutrals.b6
      contrastText: '#000000', // based on YIQ contrast
    },
    text: {
      primary: '#2D2D2D', // neutrals.b7
      secondary: '#2D2D2D', // neutrals.b7
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.03,
      hover: '#F4F8FC', // secondary.w10
    },
    divider: '#E6E6E6', // neutrals.w8
    background: {
      default: '#FFFFFF',
    },
  },
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      50: '#071627', // secondary.b10
      100: '#0B213B', // secondary.b8
      200: '#0E2C4E', // secondary.b6
      300: '#154275', // secondary.b4
      400: '#1C589C', // secondary.b2
      500: '#236EC3', // secondary
      600: '#4F8BCF', // secondary.w2
      700: '#91B7E1', // secondary.w5
      800: '#D3E2F3', // secondary.w8
      900: '#F4F8FC', // secondary.w10
      main: '#659AD5', // secondary.w3
      light: '#071627', // secondary.b10
      dark: '#E9F1F9', // secondary.w9
      contrastText: '#000000', // based on YIQ contrast
    },
    secondary: {
      50: '#330000', // primary.b10
      100: '#4D0000', // primary.b8
      200: '#660000', // primary.b6
      300: '#990000', // primary.b4
      400: '#CC0000', // primary.b2
      500: '#FF0000', // primary
      600: '#FF3333', // primary.w2
      700: '#FF8080', // primary.w5
      800: '#FFCCCC', // primary.w8
      900: '#FFF2F2', // primary.w10
      main: '#FF4D4D', // primary.w3
      light: '#330000', // primary.b10
      dark: '#FFE6E6', // primary.w9
      contrastText: '#000000', // based on YIQ contrast
    },
    success: {
      50: '#121D0C', // success.b10
      100: '#1B2C12', // success.b8
      200: '#243A18', // success.b6
      300: '#365725', // success.b4
      400: '#487431', // success.b2
      500: '#5A913D', // success
      600: '#7BA764', // success.w2
      700: '#ADC89E', // success.w5
      800: '#DEE9D8', // success.w8
      900: '#F7FAF5', // success.w10
      main: '#8CB277', // success.w3
      light: '#121D0C', // success.b10
      dark: '#EFF4EC', // success.w9
      contrastText: '#000000', // based on YIQ contrast
    },
    info: {
      50: '#011920', // info.b10
      100: '#022630', // info.b8
      200: '#033340', // info.b6
      300: '#044C61', // info.b4
      400: '#066681', // info.b2
      500: '#077FA1', // info
      600: '#3999B4', // info.w2
      700: '#83BFD0', // info.w5
      800: '#CDE5EC', // info.w8
      900: '#F3F9FA', // info.w10
      main: '#51A5BD', // info.w3
      light: '#011920', // info.b10
      dark: '#E6F2F6', // info.w9
      contrastText: '#000000', // based on YIQ contrast
    },
    warning: {
      50: '#302600', // warning.b10
      100: '#483800', // warning.b8
      200: '#604B00', // warning.b6
      300: '#907100', // warning.b4
      400: '#C09600', // warning.b2
      500: '#F0BC00', // warning
      600: '#F3C933', // warning.w2
      700: '#F8DE80', // warning.w5
      800: '#FCF2CC', // warning.w8
      900: '#FEFCF2', // warning.w10
      main: '#F5D04D', // warning.w3
      light: '#302600', // warning.b10
      dark: '#FEF8E6', // warning.w9
      contrastText: '#000000', // based on YIQ contrast
    },
    error: {
      50: '#270F0A', // error.b10
      100: '#3B160F', // error.b8
      200: '#4F1E14', // error.b6
      300: '#762C1D', // error.b4
      400: '#9E3B27', // error.b2
      500: '#C54A31', // error
      600: '#D16E5A', // error.w2
      700: '#E2A598', // error.w5
      800: '#F3DBD6', // error.w8
      900: '#FCF6F5', // error.w10
      main: '#D6806F', // error.w3
      light: '#270F0A', // error.b10
      dark: '#F9EDEA', // error.w9
      contrastText: '#000000', // based on YIQ contrast
    },
    grey: {
      50: '#1A1A1A', // neutrals.b10
      100: '#262626', // neutrals.b8
      200: '#333333', // neutrals.b6
      300: '#4D4D4D', // neutrals.b4
      400: '#666666', // neutrals.b2
      500: '#808080', // neutrals
      600: '#999999', // neutrals.w2
      700: '#C0C0C0', // neutrals.w5
      800: '#E6E6E6', // neutrals.w8
      900: '#F9F9F9', // neutrals.w10
      main: '#A6A6A6', // neutrals.w3
      light: '#1A1A1A', // neutrals.b10
      dark: '#F2F2F2', // neutrals.w9
      contrastText: '#000000', // based on YIQ contrast
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#FFFFFF',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.03,
      hover: '#123762', // secondary.b5
    },
    divider: '#333333', // neutrals.b6
    background: {
      default: '#0C0C0C', // custom as neutrals.b1 is not dark enough
      dark: '#0C0C0C', // custom as neutrals.b1 is not dark enough
      paper: '#0C0C0C', // custom as neutrals.b1 is not dark enough
    },
  },
};

export { baseDarkTheme, baselightTheme };
